

import { db } from "../../config/firebase";
import { collection, addDoc, getDoc, query, where, getDocs, doc, deleteDoc, updateDoc } from 'firebase/firestore'

const toMillis = (value) => {
    if (!value) return value;
    if (typeof value === 'number') return value;
    if (typeof value?.toDate === 'function') return value.toDate().getTime();
    if (typeof value?.seconds === 'number') return value.seconds * 1000;
    return value;
};

const normalizeProfile = (profile) => {
    if (!profile) return profile;
    return {
        ...profile,
        createdAt: toMillis(profile.createdAt),
        updatedAt: toMillis(profile.updatedAt),
        createDate: toMillis(profile.createDate),
        updateDate: toMillis(profile.updateDate),
        lastLoginDate: toMillis(profile.lastLoginDate),
        birthDate: toMillis(profile.birthDate),
        pricingDate: toMillis(profile.pricingDate),
    };
};



const getProfile = async (profileId) => {
    const docRef = await doc(db, 'users', profileId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return normalizeProfile({ ...docSnap.data(), id: docSnap.id })
    } else {
        return null;
    }
}



const getMyProfile = async (profileId) => {
    const docRef = await doc(db, 'users', profileId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return normalizeProfile({ ...docSnap.data(), id: docSnap.id })
    } else {
        return null;
    }
}

const updateMyProfile = async (profileData, userId) => {
    const docRef = await doc(db, 'users', userId);
    await updateDoc(docRef, profileData)
    const docSnap = await getDoc(docRef)
    return normalizeProfile({ ...docSnap.data(), id: docSnap.id });

}

const profileService = {
    updateMyProfile,
    getProfile,
    getMyProfile,
}

export default profileService
